import {useState} from "react";
export const RadioGroup = ({items,handleChange,selectedIndex}) => {
    const handleOptionChange=(e)=>{
        setSelectedOption(e.target.value)
        handleChange(e.target.value);
    }
    const [selectedOption,setSelectedOption]=useState(items[selectedIndex? selectedIndex:0]?.value);

    return  <div className="w-full grid gap-1  grid-cols-2">
             {

                 items?.map(({value,text},index)=>{

                   return   <label key={index} className={` p-2 rounded-lg text-sm text-center cursor-pointer border-2 border-green-500 ${selectedOption.toString() === value.toString()? 'bg-green-500 text-white':'text-green-500'}`}>
                         <input className="hidden" type="radio" value={value}
                                checked={selectedOption.toString() === value.toString()}
                                onChange={handleOptionChange} />
                         {text}
                     </label>}
                 )
             }
            </div>
}